import React from 'react';

/** In studio / In video — sempre testo + colore. */
export function ModeTag({ mode = 'studio', className = '' }) {
  const video = String(mode).toLowerCase() === 'video' || mode === true;
  return (
    <span
      className={[
        'inline-flex items-center gap-1 rounded-vc-sm px-2 py-0.5 text-vc-xs font-medium',
        video ? 'bg-vc-video-bg text-vc-video' : 'bg-vc-surface-2 text-vc-ink',
        className
      ].join(' ')}
    >
      {video ? 'In video' : 'In studio'}
    </span>
  );
}
